export default "__VITE_ASSET__1f4f9006__"